/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _get from 'lodash/get'
import { EMPTY_OBJECT } from 'constants/frozenObjects'

export const getModalStatusByName = (state, name) => _get(state, ['modals', name, 'isOpen'], false)
export const getModalDataByName = (state, { name }) => _get(state, ['modals', name, 'data'], EMPTY_OBJECT)
